module.exports = __webpack_public_path__ + "static/ttl-income-tax-certificate-a95b1f4f088ba76998188d1b7a4a4f26.pdf";